import { HttpContextToken } from '@angular/common/http';

export const RS_DEFAULT_DATE_FORMAT_FOR_REQUESTS = 'YYYY-MM-DD';
export type RsDateFormatMapContext = Record<string, string>;
export type RsDateFormatContext =
  | 'YYYY-MM-DD'
  | 'YYYY-MM-DDTHH:mm:ssZ'
  | 'MM/DD/YYYY'
  | 'DD.MM.YYYY'
  | 'HH:mm:ss'
  | 'YYYY'
  | 'DD/MM/YYYY';

/**
 * Token for specifying a default date format to use for all date fields.
 * The default value is 'YYYY-MM-DD' which only includes the date component.
 */
export const RS_DATE_FORMAT_CONTEXT = new HttpContextToken<RsDateFormatContext>(() => RS_DEFAULT_DATE_FORMAT_FOR_REQUESTS);

/**
 * Token for specifying custom date formats for specific fields.
 * The key is the field path (with dots for nested properties) and the value is the format.
 * Example: { 'createdAt': 'YYYY-MM-DDTHH:mm:ssZ', 'details.timestamp': 'HH:mm:ss' }
 */
export const RS_DATE_FORMAT_MAP_CONTEXT = new HttpContextToken<RsDateFormatMapContext>(() => ({}));

/**
 * Token to completely skip date formatting for a request.
 * Useful when you want to handle date formatting manually or for specific API requirements.
 */
export const RS_SKIP_DATE_FORMATTING_CONTEXT = new HttpContextToken<boolean>(() => false);